import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_2 = { class: "d-flex flex-row" }
const _hoisted_3 = ["id", "onUpdate:modelValue"]
const _hoisted_4 = { class: "d-flex flex-row" }
const _hoisted_5 = ["id", "onUpdate:modelValue"]
const _hoisted_6 = { class: "d-flex flex-column justify-content-center w-100 h-100" }
const _hoisted_7 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_8 = ["title", "onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-export-to-pdf" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["title", "onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-download" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["title", "onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-master-data-set" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["title", "onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!

  return (_openBlock(), _createBlock(_component_ParempiGrid, {
    class: "flex-grow-1 flex-min-height-1",
    columns: this.columns,
    items: this.items
  }, {
    name: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(item.name), 1)
    ]),
    isRenderableOutside: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          id: _ctx.$id('defaultBox_' + item.id),
          "onUpdate:modelValue": ($event: any) => ((item.isRenderableOutside) = $event),
          disabled: true
        }, null, 8, _hoisted_3), [
          [_vModelCheckbox, item.isRenderableOutside]
        ])
      ])
    ]),
    isDefault: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          id: _ctx.$id('defaultBox_' + item.id),
          "onUpdate:modelValue": ($event: any) => ((item.isDefault) = $event),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.preventUnticking($event)), ["stop"])),
          disabled: true
        }, null, 8, _hoisted_5), [
          [_vModelCheckbox, item.isDefault]
        ])
      ])
    ]),
    actions: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (item.filename != null)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-sm",
                "data-bs-toggle": "tooltip",
                title: _ctx.$t('review.labelContent.list.previewToolTip'),
                onClick: ($event: any) => (_ctx.openPreview(item))
              }, _hoisted_10, 8, _hoisted_8))
            : _createCommentVNode("", true),
          (item.origFilename != null)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-sm",
                "data-bs-toggle": "tooltip",
                title: _ctx.$t('review.labelContent.list.downloadToolTip'),
                onClick: ($event: any) => (_ctx.download(item))
              }, _hoisted_13, 8, _hoisted_11))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-sm",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t('review.labelContent.list.documentTypesToolTip'),
            onClick: ($event: any) => (_ctx.configureDocumentTypes(item))
          }, _hoisted_16, 8, _hoisted_14),
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-danger",
            "data-bs-toggle": "tooltip",
            title: _ctx.$t('review.label.edit.deleteLabelContent'),
            onClick: _withModifiers(($event: any) => (_ctx.deleteLabelContent(item)), ["prevent"])
          }, _hoisted_19, 8, _hoisted_17),
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary",
            "data-bs-toggle": "tooltip",
            onClick: _withModifiers(($event: any) => (_ctx.edit(item)), ["prevent"])
          }, _hoisted_22, 8, _hoisted_20)
        ])
      ])
    ]),
    _: 1
  }, 8, ["columns", "items"]))
}